let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("57M0n")).then(() => parcelRequire('hpQTw'));